import React, { ReactElement } from 'react';
import Button from '../button/button.component';
import useStylesControlActionButton from './control-action-button.styles';

const ControlActionButton: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const BUTTON_TITLE_LENGTH_MEDIUM_LIMIT: number = 15;
  const BUTTON_TITLE_LENGTH_LARGE_LIMIT: number = 18;

  const {
    title,
    onClick,
  } = props;

  const { classes } = useStylesControlActionButton();

  return (
    <Button
      isActive
      isDefault
      isExtended={!!title && title.length > BUTTON_TITLE_LENGTH_LARGE_LIMIT}
      isMediumSize={!!title && title.length > BUTTON_TITLE_LENGTH_MEDIUM_LIMIT
        && title.length <= BUTTON_TITLE_LENGTH_LARGE_LIMIT}
      className={classes.controlActionButton}
      onClick={onClick}
    >
      {title}
    </Button>
  );
});

export default ControlActionButton;
